import { createSelector } from 'reselect';
import { Selector } from 'react-redux';
import { RootState } from '../../../core/redux/model/rootStateModel';
import { UsersState } from './usersTypes';
import { API_REQUEST_STATE } from '../../../core/enums/apiRequestState';
import { IUsersGetResponse } from '../model/usersModel';

const getRoot = (state: RootState) => state.users;

export const apiAllUsersRequestState = createSelector<[Selector<RootState, UsersState>], API_REQUEST_STATE>(
  getRoot,
  (root: UsersState) => root.apiAllUsersRequestState,
);

export const apiAllUsersRequestError = createSelector<[Selector<RootState, UsersState>], string | null>(
  getRoot,
  (root: UsersState) => root.apiAllUsersRequestError,
);

export const allUsers = createSelector<[Selector<RootState, UsersState>], IUsersGetResponse[]>(
  getRoot,
  (root: UsersState) => root.allUsers,
);

export const apiUsersRequestState = createSelector<[Selector<RootState, UsersState>], API_REQUEST_STATE>(
  getRoot,
  (root: UsersState) => root.apiUsersRequestState,
);

export const apiUsersRequestError = createSelector<[Selector<RootState, UsersState>], string | null>(
  getRoot,
  (root: UsersState) => root.apiUsersRequestError,
);
